import { render, staticRenderFns } from "./VgBadNeustadtCitizenOfficeMonitor.vue?vue&type=template&id=4bdf1e12&scoped=true&"
import script from "./VgBadNeustadtCitizenOfficeMonitor.vue?vue&type=script&lang=js&"
export * from "./VgBadNeustadtCitizenOfficeMonitor.vue?vue&type=script&lang=js&"
import style0 from "./VgBadNeustadtCitizenOfficeMonitor.vue?vue&type=style&index=0&id=4bdf1e12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf1e12",
  null
  
)

export default component.exports